import script from "./column-field-group.vue?vue&type=script&setup=true&lang=ts"
export * from "./column-field-group.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__